import { render, staticRenderFns } from "./dealer-balance.vue?vue&type=template&id=1de03b7e&scoped=true&"
import script from "./dealer-balance.vue?vue&type=script&lang=js&"
export * from "./dealer-balance.vue?vue&type=script&lang=js&"
import style0 from "./dealer-balance.vue?vue&type=style&index=0&id=1de03b7e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de03b7e",
  null
  
)

export default component.exports